export const backColors = {
  disabledColor: "rgba(0, 108, 216, 0.4)",
  mainColor: "#006CD8"
};

const Theme = {
  backColors
};

export default Theme;
